import React from 'react'

const CartEmptyCell = () => {
  return (
   <>
   <div>Your Cart Empty</div>
   </>
  )
}

export default CartEmptyCell